import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const TECH_CHART_FOLDERABLE_APP_CONFIG = {
    appName: 'TechnicalChartApp',
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Technical Charts',
};
